import { formatarMoedaBrasileira } from "../../utils/formatarMoedaBrasileira";

function MeuBPRelatorio({ data, loading, title, subtitle }) {
    return (
        <div className="p-1 border-top border-border bg-muted">
            <div className="flex flex-wrap justify-end">
                <div className="flex flex-wrap gap-3 text-right items-center text-sm">
                    <div className="bg-muted px-3 rounded-md">
                        <p className="text-sm text-foreground mb-1">Valor Orçado: <span className="text-2x2 font-bold text-muted-foreground">{loading ? '-' : 'R$ ' + formatarMoedaBrasileira(data.totalOrcado)}</span></p>
                    </div>
                    <div className="bg-destructive/10 px-3 rounded-md">
                        <p className="text-sm text-destructive mb-1">Valor Realizado: <span className="text-2x2 font-bold text-destructive">{loading ? '-' : 'R$ ' + formatarMoedaBrasileira(data.totalRealizado)}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MeuBPRelatorio;